import { UserSession } from "@/types/user-session";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: {
	session: UserSession | null;
	sessionLoaded: boolean;
	headerIsShow: boolean;
} = {
	session: null,
	sessionLoaded: false,
	headerIsShow: true,
};

const generalSlice = createSlice({
	name: "general",
	initialState,
	reducers: {
		storeSessionToCsr(state, action: PayloadAction<null | UserSession>) {
			state.session = action.payload;
			state.sessionLoaded = true;
		},
		updateUser(state, action: PayloadAction<UserSession["data"]["user"]>) {
			state.session.data.user = action.payload;
		},
		setHeaderIsShow(state, action: PayloadAction<boolean>) {
			state.headerIsShow = action.payload;
		},
	},
});

export const { storeSessionToCsr, setHeaderIsShow, updateUser } = generalSlice.actions;
export default generalSlice;
